<template>
  <div v-bind:class="$style.logo">
    <svg
      data-v-0dd9719b=""
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="48px"
      height="48px"
      viewBox="130 75 100 80"
      preserveAspectRatio="xMidYMid meet"
      color-interpolation-filters="sRGB"
      class="header-logo"
      style="margin: auto;">
      <rect
        data-v-0dd9719b=""
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill="#333333"
        fill-opacity="0"
        class="background" />
      <g
        data-v-0dd9719b=""
        fill="#ffffff"
        transform="translate(105.58499908447266,76.5471801788919)"
        class="icon-text-wrapper icon-svg-group iconsvg">
        <g transform="translate(34.415000915527344,0)" class="iconsvg-imagesvg">
          <g>
            <rect
              fill="#ffffff"
              fill-opacity="0"
              stroke-width="2"
              x="0"
              y="0"
              width="60"
              height="60.04563468235859"
              class="image-rect" /> <svg
                x="0"
                y="0"
                width="60"
                height="60.04563468235859"
                filtersec="colorsb2186373531"
                class="image-svg-svg primary"
                style="overflow: visible;"><svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0.0186874121427536 0.03168483451008797 71.8552474975586 71.91011047363281">
                  <path
                    d="M71.85 12.61c0 2.6.05 5.21 0 7.81-.09 3.42-2.1 4.7-5.32 4.78-5.32.13-7.43-.78-7.59-4.23-.26-5.67-.21-11.36 0-17 .1-2.56 1.76-4 4.53-3.93h3.55c3.35-.15 4.72 1.74 4.82 4.79.07 2.57.01 5.17.01 7.78zM71.86 41.53v4.27c0 5.63-1.08 6.68-6.6 6.67-5.29 0-6.45-1.15-6.47-6.47 0-3.43-.07-6.87 0-10.31.11-3.79 1.49-5.11 5.18-5.19 7.16-.16 7.86.53 7.87 7.83z"
                    fill="#4c88ef" />
                  <path
                    d="M13 60.69c0 1.18-.07 2.37 0 3.55.63 8.1-2.69 7.89-9.93 7.18-2.2-.21-3-2.2-3-4.24C0 62.93 0 58.67.08 54.43c.09-3.1 1.76-4.77 5-4.63h2.84c3.73.09 5 1.36 5.06 5.21.02 1.9.02 3.79.02 5.68z"
                    fill="#e54c41" />
                  <path
                    d="M19.6 44v-2.48c0-5.88 1-6.86 6.81-6.82 5.08 0 6.2 1.15 6.25 6.34v7.82c-.05 3.15-1.55 4.87-4.83 4.79h-3.2c-3.61-.14-4.85-1.37-5-5-.08-1.65-.03-3.15-.03-4.65z"
                    fill="#f9be15" />
                  <path
                    d="M52.14 62.47v2.84c0 5.46-.93 6.36-6.42 6.36s-6.35-.89-6.37-6.42c0-2.6-.05-5.21 0-7.81.08-2.83 1.5-4.4 4.44-4.37h3.2c3.88.08 5 1.2 5.11 5.13.07 1.42.04 2.8.04 4.27z"
                    fill="#3fa95b" />
                  <path
                    d="M71.85 64.66c0 6.14-.82 7-6.52 7s-6.55-1-6.54-7c0-5.86 1.05-6.93 6.73-6.92 5.33 0 6.33 1.09 6.33 6.92z"
                    fill="#4c88ef" />
                  <path
                    d="M26.23 58.71c5.35 0 6.42 1.08 6.42 6.47S31.34 72 26 71.94s-6.43-1.27-6.43-6.56c.02-5.52 1.18-6.68 6.66-6.67z"
                    fill="#f8be18" />
                  <path
                    d="M52.15 40.81c0 6.16-5.37 9.21-10.68 6.32a4 4 0 0 1-2-3.14c-.13-.93 0-1.89-.1-2.83-.56-8.43 2.93-8 9.85-7.16 3.67.47 2.78 4.29 2.93 6.81zM45.91 15.56c5.37 0 6.27.94 6.25 6.52 0 5.21-1 6.24-6.22 6.24-5.7 0-6.61-.9-6.59-6.56.01-5.34.93-6.2 6.56-6.2z"
                    fill="#3fa95b" />
                </svg></svg>
          </g>
        </g>
        <!---->
      </g>
    </svg>
  </div>
</template>

<script>
  /*
  Copyright (C) 2021 owner Roman Piontik R.Piontik@mail.ru

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

          http://www.apache.org/licenses/LICENSE-2.0

  In any derivative products, you must retain the information of
  owner of the original code and provide clear attribution to the project

          https://dochub.info

  The use of this product or its derivatives for any purpose cannot be a secret.

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
      Rostislav Kabalin <kabalin2009@yandex.ru>

  Contributors:
      Rostislav Kabalin <kabalin2009@yandex.ru>
  */

  export default {};
</script>

<style module>
  .logo {
    padding: 4px;
    background: #fff;
    border-radius: 17px;
    width: 48px;
    height: 48px;
  }
</style>
